import { Link } from 'react-router-dom';
import register from '../../assets/images/icons/register.svg';
import Button from '../../components/Button';
import { ButtonContainer } from '../../components/Form';
import Loader from '../../components/Loader';
import { Container } from './styles';

import Transitions from '../../components/Transition';
import BillingAddress from './components/BillingAddress';
import CompanyAddress from './components/CompanyAddress';
import CompanyData from './components/CompanyData';
import ContactAndAccess from './components/ContactAndAccess';
import Title from './components/Title';
import useSignup from './useSignup';

export default function Signup() {
  const {
    isLoading,
    getErrorMessageByFieldName,
    cpf,
    handleCpfChange,
    cnpj,
    handleCnpjChange,
    cnpjPagto,
    handleCnpjPagtoChange,
    pagadorNFSeparada,
    setPagadorNFSeparada,
    password,
    handlePasswordChange,
    passwordConfirmation,
    handlePasswordConfirmationChange,
    email,
    handleEmailChange,
    signup,
    isReadyToSignup,
    emailConfirmation,
    handleEmailConfirmationChange,
    companyName,
    handleCompanyNameChange,
    fantasyName,
    handleFantasyNameChange,
    employeesQty,
    handleEmployeesQtyChange,
    stateRegistration,
    handleStateRegistrationChange,
    municipalRegistration,
    handleMunicipalRegistrationChange,
    companyCellphone,
    handleCompanyCellphoneChange,
    cep,
    handleCepChange,
    uf,
    city,
    district,
    street,
    handleNumberChange,
    number,
    handleComplementChange,
    complement,
    setBillingAddres,
    billingAddress,
    billingCep,
    handleBillingCepChange,
    billingUf,
    billingCity,
    billingDistrict,
    billingStreet,
    handleBillingNumberChange,
    billingNumber,
    handleBillingComplementChange,
    billingComplement,
    name,
    handleNameChange,
    contactCellphone,
    handleContactCellphoneChange,
    isGettingCepData,
    isGettingBillingCepData,
    mustFillManualy,
    billingMustFillManualy,
    handleDistrictChange,
    handleStreetChange,
    handleBillingDistrictChange,
    handleBillingStreetChange,
  } = useSignup();

  return (
    <Transitions>
      <Loader isLoading={isLoading} />
      <Container>
        <div className="asideGif">
          <img src={register} alt="busGif" />
        </div>

        <div className="asideLogin">
          <Title />
          <div className="loginForm">
            <CompanyData
              getErrorMessageByFieldName={getErrorMessageByFieldName}
              cnpj={cnpj}
              handleCnpjChange={handleCnpjChange}
              cnpjPagto={cnpjPagto}
              handleCnpjPagtoChange={handleCnpjPagtoChange}
              pagadorNFSeparada={pagadorNFSeparada}
              setPagadorNFSeparada={setPagadorNFSeparada}
              companyName={companyName}
              handleCompanyNameChange={handleCompanyNameChange}
              fantasyName={fantasyName}
              handleFantasyNameChange={handleFantasyNameChange}
              employeesQty={employeesQty}
              handleEmployeesQtyChange={handleEmployeesQtyChange}
              stateRegistration={stateRegistration}
              handleStateRegistrationChange={handleStateRegistrationChange}
              municipalRegistration={municipalRegistration}
              handleMunicipalRegistrationChange={handleMunicipalRegistrationChange}
              companyCellphone={companyCellphone}
              handleCompanyCellphoneChange={handleCompanyCellphoneChange}
            />

            <CompanyAddress
              getErrorMessageByFieldName={getErrorMessageByFieldName}
              isGettingCepData={isGettingCepData}
              cep={cep}
              handleCepChange={handleCepChange}
              uf={uf}
              city={city}
              district={district}
              street={street}
              handleNumberChange={handleNumberChange}
              number={number}
              handleComplementChange={handleComplementChange}
              complement={complement}
              mustFillManualy={mustFillManualy}
              handleDistrictChange={handleDistrictChange}
              handleStreetChange={handleStreetChange}
            />

            <BillingAddress
              billingAddress={billingAddress}
              setBillingAddres={setBillingAddres}
              getErrorMessageByFieldName={getErrorMessageByFieldName}
              isGettingBillingCepData={isGettingBillingCepData}
              billingCep={billingCep}
              handleBillingCepChange={handleBillingCepChange}
              billingUf={billingUf}
              billingCity={billingCity}
              billingDistrict={billingDistrict}
              billingStreet={billingStreet}
              handleBillingNumberChange={handleBillingNumberChange}
              billingNumber={billingNumber}
              handleBillingComplementChange={handleBillingComplementChange}
              billingComplement={billingComplement}
              billingMustFillManualy={billingMustFillManualy}
              handleBillingDistrictChange={handleBillingDistrictChange}
              handleBillingStreetChange={handleBillingStreetChange}
            />

            <ContactAndAccess
              getErrorMessageByFieldName={getErrorMessageByFieldName}
              cpf={cpf}
              handleCpfChange={handleCpfChange}
              name={name}
              handleNameChange={handleNameChange}
              contactCellphone={contactCellphone}
              handleContactCellphoneChange={handleContactCellphoneChange}
              email={email}
              handleEmailChange={handleEmailChange}
              emailConfirmation={emailConfirmation}
              handleEmailConfirmationChange={handleEmailConfirmationChange}
              password={password}
              handlePasswordChange={handlePasswordChange}
              passwordConfirmation={passwordConfirmation}
              handlePasswordConfirmationChange={handlePasswordConfirmationChange}
            />
          </div>

          <ButtonContainer flexDirection='column'>
            <Button type="button" onClick={signup} disabled={!isReadyToSignup}>
              Realizar Cadastro
            </Button>
            <div className="backToLogin">
              <Link to="/">Realizar login</Link>
            </div>
          </ButtonContainer>
        </div>
      </Container>
    </Transitions>
  );
}
